const config = {
  version: '2.9.0',
  type: 'js'
};

export default config;


// WEBPACK FOOTER //
// ./src/config.ts